/* global arNextOptions */
import {applyBasketState} from './set-state-user';
export async function refreshBasketFly() {
    const basket = document.querySelector('#basket_line .basket_fly');

    if (!basket) return;

    const params = document.querySelector('#fly_basket_params');

    if (!params) return;

    beforeRefreshBasketFly(basket);

    const response = await fetch(`${arNextOptions.SITE_DIR}ajax/basket_fly.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
        },
        body: new URLSearchParams({
            PARAMS: params.value,
        }),
    });

    if (!response.ok) {
        throw new Error(`Basket refresh failed: ${response.status}`);
    }

    const html = await response.text();

    basket.innerHTML = html;
    basket.classList.add('loaded');

    afterRefreshBasketFly();
}

function beforeRefreshBasketFly(basket) {
    const activeTab = document?.querySelector('.basket-fly__tabs li.basket-fly__tab_active');
    if (!activeTab) {
        return;
    }
    sessionStorage.setItem('basket_active_tab', activeTab.getAttribute('item-section'));
    const bodyItems = basket.querySelectorAll('.basket-fly__items-body');

    if (bodyItems) {
        bodyItems.forEach((body) => {
            let typeBody = body.closest('.tabs_content.basket > li');
            if (typeBody.getAttribute('item-section') === activeTab.getAttribute('item-section')) {
                sessionStorage.setItem('basket_scroll_top', body.scrollTop.toString());
            }
        });
    }
}

function afterRefreshBasketFly() {
    const basket = document.querySelector('#basket_line .basket_fly');

    if (!basket) {
        return;
    }

    const activeTab = sessionStorage.getItem('basket_active_tab');

    applyBasketState(basket, activeTab);
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            const scrollTop = sessionStorage.getItem('basket_scroll_top');

            const body = basket.querySelector(
                `.tabs_content.basket > li[item-section="${activeTab}"] .basket-fly__items-body`
            );

            if (body && scrollTop !== null) {
                body.scrollTop = parseInt(scrollTop, 10);
            }
            sessionStorage.removeItem('basket_scroll_top');
        });
    });
    sessionStorage.removeItem('basket_active_tab');
}
